/**
 * Data & settings' footer line. ehr#375 (Jay 10-30): unsaved sliding scale tiers count too, and
 * Save changes saves them (the footer said "No unsaved changes" over a tier typed in, and Save
 * changes skipped it, so the tier never reached the client chart).
 */
export function dsFootNote(p: { practice: boolean; autoLogout: boolean; tiers: boolean }): string {
  return p.practice || p.autoLogout || p.tiers ? 'Unsaved changes' : 'No unsaved changes';
}
